import React from 'react';
import { View } from 'react-native';
import { MaterialCommunityIcons } from "@expo/vector-icons";

function BudgetIcon(props) {
  return (
    <View style={{marginBottom: 5}}>
      <MaterialCommunityIcons name="cash-multiple" {...props.style} size={22}/>
    </View>
  )
}

export default BudgetIcon;
